import { RewardPool, RewardPoolTicketCurrencyType } from '@shared/api/types/rewardPools';

import { DialogProps } from '@radix-ui/react-dialog';
import { CustomDialog } from '@ui/uikit/components/common/Dialog';

import { GetTicketsForm } from './GetTicketsForm';

type Props = DialogProps & {
  currencyType: RewardPoolTicketCurrencyType;
  rewardPool: RewardPool;
  closeModal: () => void;
};

export const GetTicketsModal = ({ currencyType, rewardPool, closeModal, ...props }: Props) => {
  const submitHandler = () => {
    closeModal();
  };

  return (
    <CustomDialog {...props} title="Get Tickets" titleIsLeftAligned size="sm">
      <GetTicketsForm
        rewardPool={rewardPool}
        currencyType={currencyType}
        onSubmit={submitHandler}
      />
    </CustomDialog>
  );
};
